import {baseProdConfig} from '../base/prod.config';
import {cbssportsStagingConfig} from './staging.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cbssportsProdConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseProdConfig, cbssportsStagingConfig, {
  environmentName: 'Cbs Sports Production Environment',
  hubApi: 'https://cms.cbssports.com',
  ionicEnvName: 'prod',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cbssports/prod.config.ts